<span mat-dialog-title class="w-full">{{
  perspective().id && !goToInfo()
    ? ('Vuoi modificare o clonare la vista corrente ?' | siaTranslate)
    : ('Informazioni vista' | siaTranslate)
}}</span>
@if (!perspective().id || goToInfo()) {
  <div mat-dialog-content>
    <div
      class="flex h-full w-full flex-wrap items-center justify-center gap-2 p-2"
    >
      <sia-text-box
        [value]="perspective().description ?? ''"
        (valueChange)="onDescriptionChange($event)"
        label="Descrizione"
        [autofocus]="true"
        class="w-full"
      ></sia-text-box>
      <sia-check-box
        class="w-full"
        [value]="isDefault()"
        (valueChange)="onDefaultChange($event)"
        label="Default"
      ></sia-check-box>
    </div>
  </div>
}

<div mat-dialog-actions align="end" class="w-full">
  @if (perspective().id && !goToInfo()) {
    <button mat-button color="primary" (click)="updatePerspective()">
      <mat-icon>edit</mat-icon>
      Modificare
    </button>
    <button mat-button color="warn" (click)="createNewPerspective()">
      <mat-icon>content_copy</mat-icon>
      Clonare
    </button>
  } @else {
    <button mat-button color="primary" (click)="save()">
      <mat-icon>save</mat-icon>
      Salva
    </button>
    <button mat-button class="error" (click)="close()">
      <mat-icon>cancel</mat-icon>
      Annulla
    </button>
  }
</div>
